import type { AtelierGatewayApp } from "gateway-atelier";
import { type AppClientOptions, appClient } from "./client";

// Client of the Atelier app (ADR-040, ADR-154): the access of the external users at /auth (ADR-148); the domains'
// routes come under /api with P6.4.

export function atelierClient(options: AppClientOptions = {}) {
  const { api, root } = appClient<AtelierGatewayApp>(options);
  return { api, auth: root.auth };
}
